<template>
  <v-simple-table
    dense
    class="my-3 hundred-point__table"
    data-testid="hundred-point-table"
  >
    <thead>
      <tr class="font-weight-bold hundred-point__header">
        <th class="text-left points-header">Points</th>
        <th class="text-left">Document type</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(group, index) in groupedItems">
        <tr
          v-for="(item, idx) in group.documents"
          :key="`${index}-${idx}`"
          :class="{ 'odd-group': index % 2 !== 0 }"
        >
          <td v-if="idx === 0" :rowspan="group.documents.length">
            {{ group.points }}
          </td>
          <td>
            <span
              v-for="(documentType, partIndex) in item.boldDocumentType"
              :key="partIndex"
            >
              <strong>{{ documentType }}</strong>
              {{
                item.junctionParts && item.junctionParts[partIndex]
                  ? ' ' + item.junctionParts[partIndex] + ' '
                  : ''
              }}
            </span>
            {{ item.text }}
          </td>
        </tr>
      </template>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'HundredPointCheck',
  data() {
    return {
      items: [
        {
          points: '40 points',
          boldDocumentType: ['Council rates notice']
        },
        {
          points: '40 points',
          boldDocumentType: ['Lease agreement'],
          text: 'through a registered real estate agent for a period of at least 6 months or rental board bond receipt'
        },
        {
          points: '40 points',
          boldDocumentType: ['Exchanged contract of sale'],
          text: 'with settlement to occur within the applicable school year'
        },
        {
          points: '20 points',
          boldDocumentType: ['Private rental agreement'],
          text: 'for a period of at least 6 months'
        },
        {
          points: '20 points',
          boldDocumentType: ['Centrelink payment statement'],
          text: 'showing home address'
        },
        { points: '20 points', boldDocumentType: ['Electoral roll statement'] },
        {
          points: '15 points',
          boldDocumentType: ['Electricity', 'gas'],
          junctionParts: ['or'],
          text: 'bill showing the service address*'
        },
        {
          points: '15 points',
          boldDocumentType: ['Water bill'],
          text: 'showing the service address*'
        },
        {
          points: '15 points',
          boldDocumentType: ['Telephone', 'internet bill'],
          junctionParts: ['or'],
          text: 'showing the service address*'
        },
        {
          points: '15 points',
          boldDocumentType: ['Drivers licence', ' government issued ID'],
          junctionParts: ['or'],
          text: 'showing home address*'
        },
        {
          points: '15 points',
          boldDocumentType: ['Home building', ' home contents insurance'],
          junctionParts: ['or'],
          text: 'showing the service address'
        },
        {
          points: '15 points',
          boldDocumentType: [
            'Motor vehicle registration ',
            'compulsory third party insurance policy'
          ],
          junctionParts: ['or'],
          text: 'showing home address'
        },
        {
          points: '15 points',
          boldDocumentType: ['Statutory declaration'],
          text: 'stating the child’s residential address, how long they have lived there, and any supporting information or documentation of this'
        }
      ]
    }
  },
  computed: {
    groupedItems() {
      const groups = {}
      this.items.forEach((item) => {
        if (!groups[item.points]) {
          groups[item.points] = { points: item.points, documents: [] }
        }
        groups[item.points].documents.push(item)
      })
      return Object.values(groups)
    }
  }
}
</script>

<style lang="scss" scoped>
.hundred-point__table {
  ::v-deep .v-table__wrapper {
    overflow-x: hidden !important;
    border: 1px solid $ads-grey-03;
  }

  .points-header {
    min-width: 110px;
  }

  td,
  th {
    border: 1px solid $ads-grey-03;
    font-size: 14px !important;
    color: $ads-grey-01 !important;
    min-height: 35px;
    line-height: 24px;
    padding: 8px 16px !important;
    vertical-align: top;
    word-break: break-word;
    white-space: normal; // important for wrapping
  }

  ::v-deep tr:hover {
    background-color: inherit !important;
  }

  ::v-deep {
    .hundred-point__header {
      background-color: $ads-grey-04;
      &:hover {
        background: $ads-grey-04 !important;
      }
    }

    tr.odd-group {
      background: rgba(220, 220, 220, 0.2);

      &:hover {
        background: rgba(220, 220, 220, 0.2) !important;
      }
    }
  }
}
</style>
